import { Box, IconButton } from '@mui/material';
import { DeleteOutlined, AddCircle } from '@mui/icons-material';
import theme from '../../theme';
import { useError } from '../../contexts/ErrorContext';

const TYPE_STYLES = {
  default: {
    width: { xs: '100%', md: '40%', lg: '40%' },
    minWidth: { xs: 320, md: 291, lg: 291 },
    aspectRatio: '3/2',
  },
  playlist: {
    width: { xs: '100%', md: '32%', lg: '24%' },
    minWidth: { xs: 240, md: 220, lg: 220 },
    maxWidth: { lg: 220 },
    aspectRatio: '1/1.36',
  },
  square: {
    width: { xs: '100%', md: '30%', lg: '20%' },
    minWidth: { xs: 320, md: 229, lg: 180 },
    aspectRatio: '1/1',
  },
  banner: {
    width: '100%',
    aspectRatio: '1180/200',
  },
  mobileBanner: {
    width: { xs: '100%', md: 320 },
    aspectRatio: '320/100',
  },
};

const ThumnailEditor = ({
  thumbnailPreview,
  handleThumbnailUpload,
  handleThumbnailDelete,
  type = 'default',
}) => {
  const { showError } = useError();
  const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB in bytes

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      // 파일 크기 검증
      if (file.size > MAX_FILE_SIZE) {
        showError('최대 20MB까지 업로드할 수 있습니다.');
        event.target.value = ''; // 파일 선택 초기화
        return;
      }

      // 파일 타입 검증 (이미지 파일인지 확인)
      if (!file.type.startsWith('image/')) {
        showError('이미지 파일만 선택할 수 있습니다.');
        event.target.value = '';
        return;
      }

      // 검증을 통과한 경우 원래 핸들러 호출
      handleThumbnailUpload(event);
    }
  };

  const typeStyle = TYPE_STYLES[type] || TYPE_STYLES.default;

  return (
    <Box
      sx={{
        border: '1px dashed #ccc',
        borderRadius: 1,
        backgroundColor: theme.palette.grey.bg,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        ...typeStyle,
      }}
    >
      {thumbnailPreview ? (
        <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
          <img
            src={thumbnailPreview}
            alt="Thumbnail preview"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '8px',
            }}
          />
          <IconButton
            onClick={handleThumbnailDelete}
            sx={{
              width: '32px',
              height: '32px',
              position: 'absolute',
              top: 15,
              right: 15,
              backgroundColor: theme.palette.red,
              color: 'white',
            }}
          >
            <DeleteOutlined color="white" />
          </IconButton>
        </Box>
      ) : (
        <label htmlFor="thumbnail-upload">
          <IconButton
            component="span"
            sx={{
              fontSize: '32px',
              color: theme.palette.black[6],
              '&:hover': { backgroundColor: 'transparent' },
            }}
          >
            <AddCircle fontSize="inherit" />
          </IconButton>
          <input
            id="thumbnail-upload"
            type="file"
            accept="image/png, image/jpeg"
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
        </label>
      )}
    </Box>
  );
};

export default ThumnailEditor;
